<template>
  <div class="flex mb-10 lg:flex-row flex-col max:lg:pb-10">
    <div class="w-2/12 text-gray-700 sticky h-24 max:lg:w-full max:lg:static max:lg:h-auto max:lg:px-6 max:sm:px-2" style="top: 10rem">
      <div class="max:lg:flex">
        <h2 class="font-medium text-2xl ml-2 max:lg:flex max:lg:items-center max:lg:text-base max:lg:ml-0 max:lg:mr-4 max:lg:whitespace-nowrap">My Profile</h2>
        <div ref="menu" class="mt-8 scroll-h-none max:lg:mt-0 max:lg:overflow-x-scroll">
          <ul class="leading-loose max:lg:flex">
            <router-link
              @click.native="scrollMenu(0)"
              tag="li"
              to="/profile"
              active-class="font-medium bg-gray-300 rounded-lg"
              data-balloon-pos="right"
              class="px-3 py-1 mt-3 hover:bg-gray-300 rounded-lg max:lg:mt-0 max:lg:ml-4"
              exact
            >
              <a class="inline-flex items-center">
                <!--<svg class="block h-3" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--<path d="M1 1L7 7L1 13" stroke="#4A5568" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
                <!--</svg>-->
                <span class="ml-3 block max:lg:m-0 max:lg:whitespace-nowrap">Personal Information</span>
              </a>
            </router-link>
            <router-link
              @click.native="scrollMenu(120)"
              tag="li"
              to="/profile/education"
              active-class="font-medium bg-gray-300 rounded-lg"
              data-balloon-pos="right"
              class="px-3 py-1 mt-3 hover:bg-gray-300 rounded-lg max:lg:mt-0 max:lg:ml-4"
              exact
            >
              <a class="inline-flex items-center">
                <span class="ml-3 block max:lg:m-0 max:lg:whitespace-nowrap">Education Information</span>
              </a>
            </router-link>
            <router-link
              @click.native="scrollMenu(300)"
              tag="li"
              to="/profile/change-password"
              active-class="font-medium bg-gray-300 rounded-lg"
              data-balloon-pos="right"
              class="px-3 py-1 mt-3 hover:bg-gray-300 rounded-lg max:lg:mt-0 max:lg:ml-4"
              exact
            >
              <a class="inline-flex items-center">
                <span class="ml-3 block max:lg:m-0 max:lg:whitespace-nowrap">Change Password</span>
              </a>
            </router-link>
          </ul>
        </div>
      </div>
    </div>
    <div class="lg:w-7/12 w-full text-gray-700 px-6 max:lg:mt-8 mb-4 md:mb-8 max:sm:px-2">
      <router-view></router-view>
    </div>
    <div class="w-3/12 mt-4 md:mt-20 max:lg:w-full max:lg:px-6 max:sm:px-2">
      <div class="bg-white flex items-center flex-col justify-center rounded shadow max:lg:flex-row max:sm:flex-col">
        <div class="p-6 relative max:sm:pb-2">
          <AgAvatar class="border avatar-dynamic" :fullname="profile.name" :image="profile.photo_url" :size="150">
            <input
              v-validate="'image'"
              type="file"
              ref="profileImage"
              name="profile_image"
              title="Click here to upload new image"
              class="cursor-pointer absolute h-full w-full opacity-0 top-0 left-0"
              @change="uploadProfileImage()"
            />
          </AgAvatar>
        </div>
        <div class="px-8 pt-6 w-full max:lg:py-6">
          <p class="mb-2 text-center max:lg:text-left">Hello {{ profile.first_name }},</p>
          <p class="mb-4 leading-loose text-gray-800 tracking-wide text-justify max:lg:text-left max:lg:tracking-normal">
            It's my pleasure to assist you with your processing and help you achieve your dreams. Please feel free to contact me for any queries.
            <br />
          </p>
          <div class="flex items-center mt-6 justify-center max:lg:justify-start">
            <AgAvatar :fullname="profile.assignee.name" :image="profile.assignee.photo_url" :size="40"></AgAvatar>
            <div class="flex flex-col ml-4">
              <span class="text-gray-800 text-medium">
                {{ profile.assignee.name }}
              </span>
              <span class="text-blue-700 text-medium break-all">
                {{ profile.assignee.email }}
              </span>
            </div>
          </div>
        </div>
        <span class="block w-full mt-6 max:xl:w-0"></span>
        <!--<button @click="composeEmail = !composeEmail" type="button" class="inline-flex px-4 py-6 items-center text-gray-700 font-medium w-full justify-center">-->
        <!--<svg width="20" height="16" viewBox="0 0 20 16" class="block fill-current" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0H18C19.103 0 20 0.897 20 2V13C20 14.103 19.103 15 18 15H10V13H18V4L11.6 8.8C11.422 8.933 11.211 9 11 9C10.789 9 10.578 8.933 10.4 8.8L4 4V6H2V2C2 0.897 2.897 0 4 0ZM4.666 2L11 6.75L17.334 2H4.666Z"/>-->
        <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M0 8H7V10H0V8ZM2 12H8V14H2V12ZM9 18V16H5V18H9Z"/>-->
        <!--</svg>-->
        <!--<span class="ml-3 block">Send Email</span>-->
        <!--</button>-->
      </div>
    </div>
    <!--<ComposeEmail v-if="composeEmail" @close="composeEmail = !composeEmail"></ComposeEmail>-->
  </div>
</template>
<script>
import axios from 'axios';
import AgAvatar from '@/components/Avatar.vue';
import { getProfile } from '../api/calls';
// import ComposeEmail from "@/components/ComposeEmail.vue";

export default {
  name: 'MyProfile',
  components: {
    AgAvatar,
    // ComposeEmail
  },
  data() {
    return {
      composeEmail: false,
      profile: {
        assignee: {},
      },
    };
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const response = await getProfile();
      next((vm) => {
        vm.profile = response.data;
      });
    } catch (error) {

    }
  },
  mounted() {
    if(this.$route.path === '/profile/change-password') this.scrollMenu(300);
    if(this.$route.path === '/profile/education') this.scrollMenu(120);
  },
  methods: {
    scrollMenu(amount) {
      const menu = this.$refs.menu
       menu.scrollTo({
        left: amount,
        behavior: 'smooth',
      })
    },
    async fetch() {
      let response = await axios.get('/api/profile');
      this.profile = response.data;
    },
    uploadProfileImage() {
      const image = this.$refs.profileImage.files[0];
      let formData = new FormData();
      formData.append('profile_image', image);
      this.$loading(true);
      axios
        .post('/api/profile-image', formData)
        .then((response) => {
          this.fetch();
          this.$loading(false);
        })
        .catch((error) => {
          this.$loading(false);
          this.$toasted.error('Oops, Something went wrong..');
        });
    },
  },
};
</script>
<style>
.speech-bubble {
  position: relative;
  top: 5px;
}

.speech-bubble:after {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 0;
  height: 0;
  border: 20px solid transparent;
  border-bottom-color: #edf2f7;
  border-top: 1px;
  border-left: 1px;
  margin-left: -10px;
  margin-top: -20px;
  box-shadow: -1px 0px 0px 0 #e4e7ea;
}

.scroll-h-none::-webkit-scrollbar {
  height: 0em;
}

.avatar-dynamic {
  width: 8rem !important;
  height: 8rem !important;
}
</style>
